import axios from 'axios';
import { sessionStorageManager as storage } from './storage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = storage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
                                                                                
// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect on 401 for authenticated requests (not login/register)
    // Check if the request was to a protected endpoint (has token in header)
    const isAuthEndpoint = error.config?.url?.includes('/auth/');
    const hasToken = error.config?.headers?.Authorization;
    
    if (error.response?.status === 401 && hasToken && !isAuthEndpoint) {
      // Session expired - clear token and project context, redirect
      storage.clear401Storage();
      window.location.href = '/login';
    }
                                                                          
    return Promise.reject(error);
  }
);

export default api;
